import { model as i18n } from '!/i18n'
import { combine } from 'effector'
import {
  ssePurchasesModel,
  type AdjustPurchaseableFn,
} from '~/features/payment/sse-purchases'
import type { ViewRow } from './lib'
import { $rows } from './rows'

// --- old formatters helpers, TODO: refactor this
import { formatContinueWatchingItem } from '~/entities/continue-watching'
import { formatLiveEventWithPrice } from '~/entities/live-events/events'
import { formatVodBundleInfoToUi } from '~/entities/movies/bundles'
import { formatPartnerProductItem } from '~/entities/partner-product'
import { formatBundleRowWithContent } from '~/entities/shows/bundles'
import { formatTvBundleRowWithContent } from '~/entities/tv/bundles'
import {
  extendMediaItemByLabelPrice,
  extendMediaItemByLabelPriceTvChannel,
} from '~/shared/tools'
// ---

export const $viewRows = combine(
  $rows,
  i18n.$t,
  ssePurchasesModel.$adjust,
  (rows, { t }, adjustFactory) =>
    rows.map(({ id, desc, data, hasMore }) => {
      // row name/title
      const key = desc.localizedTitleKey

      const view: ViewRow = {
        id,
        content: [],
        isMoreThanOnePage: Boolean(hasMore),
        appearance: {
          ...desc,
          title: key ? t(key) || desc.title : desc.title,
          description: desc.description,
        },
        type: data.type,
      }

      // if empty row
      if (
        !('payload' in data) ||
        data.payload == null ||
        !Array.isArray(data.payload) ||
        data.payload.length === 0
      ) {
        return view
      }

      // format row content items
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      view.content = data.payload.map((item: any) => {
        let adjust: AdjustPurchaseableFn
        switch (desc.contentType) {
          case 'VOD':
            adjust = adjustFactory('vod', 'vodSet')
            return extendMediaItemByLabelPrice(adjust(item))
          case 'TV_CHANNEL':
            adjust = adjustFactory('channel', 'channelSet')
            return extendMediaItemByLabelPriceTvChannel(adjust(item))
          case 'TV_SHOW':
            adjust = adjustFactory('tvShow', 'tvShowSet')
            return extendMediaItemByLabelPrice(adjust(item))
          case 'LIVE_EVENT':
            adjust = adjustFactory('liveEvent')
            return formatLiveEventWithPrice(adjust(item))
          case 'MIXED':
            return formatContinueWatchingItem(item, t)
          case 'PARTNER_PRODUCT':
            return formatPartnerProductItem(item)
          case 'VOD_BUNDLE':
            adjust = adjustFactory('vodSet')
            return formatVodBundleInfoToUi(t, adjust)(item)
          case 'TV_BUNDLE':
            adjust = adjustFactory('channelSet')
            return formatTvBundleRowWithContent(t, adjust)(item)
          case 'TV_SHOW_BUNDLE':
            adjust = adjustFactory('tvShowSet')
            return formatBundleRowWithContent(t, adjust)(item)
        }
      })

      return view
    })
)
